import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  sider: {
    position: 'relative',
    background: 'var(--background-paper)',
    boxShadow: 'var(--shadows-4)',
    zIndex: 2,
    scrollbarWidth: 'none',
    overflow: 'hidden',
    width: '120px',
    minWidth: '120px',
    maxWidth: '120px',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',

    '-ms-overflow-style': 'none',

    '& *': {
      ...mixins.noScroll,
    },

    '&.isSiderClosed': {
      transition: 'all .2s',
      width: '44px',
      minWidth: '44px',
      maxWidth: '44px',

      '& .savingLoadingDataIndicator': {
        '& .spinner': {
          margin: '0 auto',
        },

        '& .text': {
          display: 'none',
        },
      },

      '@media screen and (min-width: 1441px)': {
        width: '56px',
        minWidth: '56px',
        maxWidth: '56px',
      },
    },

    '@media screen and (min-width: 1441px)': {
      width: '153px',
      minWidth: '153px',
      maxWidth: '153px',
    },
  },

  logoContainer: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '120px',
    minHeight: '120px',

    '& > div': {
      width: '100%',
    },

    '& img': {
      width: '100%',
      height: 'auto',
      transition: 'linear',
      transitionDuration: '0.1s',
    },

    '& svg': {
      transition: 'linear',
      transitionDuration: '0.1s',
    },

    '@media screen and (min-width: 1441px)': {
      height: '153px',
      minHeight: '153px',
    },
  },

  logoContainerCollapsed: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '44px',

    '& img': {
      width: '100%',
      height: '56px',
      transition: 'linear',
    },

    '& svg': {
      width: '50%',
      height: '50%',
      transition: 'linear',
    },

    '@media screen and (min-width: 1441px)': {
      width: '56px',
    },
  },

  menu: {
    overflow: 'scroll',
    padding: '0 0 80px 0',

    '& .menuItem': {
      transition: 'linear',
      transitionDuration: '0s',
      whiteSpace: 'pre-wrap',
      color: 'var(--whiteToEmperor)',
      wordBreak: 'break-all',
    },

    '&.collapsed': {
      '& .menuItem': {
        padding: '12px 0',

        '& .menuItemContent': {
          margin: '0 auto',

          '& .viboIcon': {
            margin: 0,
          },
        },

        '& span': {
          display: 'none',
        },
      },

      '& .supportMenu': {
        paddingLeft: '12px!important',

        '&:before': {
          left: '11px',
        },
      },
    },
  },

  supportMenu: {
    maxHeight: 0,
    transition: 'max-height 0.15s ease-out',
    overflow: 'hidden',
    paddingLeft: '16px!important',
    position: 'relative',

    '&.isOpen': {
      maxHeight: '500px',
      transition: 'max-height 0.25s ease-in',
    },

    '&:before': {
      content: '""',
      backgroundColor: 'var(--text-hint)',
      borderRadius: '2px',
      width: '1px',
      top: '8px',
      bottom: '8px',
      left: '15px',
      position: 'absolute',
    },

    '& > .menuItem': {
      paddingLeft: '7px!important',
      paddingRight: '7px!important',

      '&.rc-menu-item-selected': {
        border: 'none!important',
      },
    },
  },
}));

export default useStyles;
